(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name messages.controller:NewMessageCtrl
     *
     * @description
     *
     */
    angular
            .module('messages')
            .controller('NewMessageCtrl', NewMessageCtrl);

    function NewMessageCtrl($rootScope, MessagesService, ValidationService, $log, $timeout, $state, HelperService, GoogleTagManagerHelperService) {
        var vm = this;
        vm.ctrlName = 'NewMessageCtrl';
        vm.countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
        vm.isReplyMessage = false;
        vm.inputOptions = {
          maxLength: ''
        };

        if(vm.countryCode != 'hr'){ //only BH, SR, MNE have maxlength , SLO dont have subject
          vm.inputOptions.maxLength = 60;
        }

        vm.init = function () {
            vm.regex = ValidationService.getRegexPatternsForValidation();

            if ($state.params.messageId) {
                MessagesService.getById($state.params.messageId)
                        .then(function (response) {
                            $log.debug("messageByID", response);

                            vm.sendMessageObject.subject = "RE: " + response.subject;
                            vm.sendMessageObject.body = HelperService.formatResponseBody(response.body, true);

                            vm.isReplyMessage = true;
                            $timeout(function () {
                                setCaretToPos(document.getElementById("msgBody"), 0);
                            });
                        })
                        .catch(function (error) {
                            $log.error(error);
                        });

            }
        };

        vm.showSuccessSection = false;

        vm.sendMessageObject = {
            subject: "",
            body: ""
        };

        vm.resetSendMessageObject = function () {
            vm.sendMessageObject.subject = "";
            vm.sendMessageObject.body = "";
        };

        vm.successfulMessageSubject = "";




        vm.sendMessage = function (sendMessageForm) {
          if (vm.sendButtonPressed) return;
          if(sendMessageForm.$invalid) return;
            vm.sendButtonPressed = true;
            MessagesService.sendMessage(vm.sendMessageObject)
                    .then(function (response) {
                        $log.debug("message send response", response);
                        vm.showSuccessSection = true;
                        vm.resetSendMessageObject();
                        vm.successfulMessageSubject = response.subject;
                        GoogleTagManagerHelperService.pushEvent('Messages', 'MessageSent', 'Message sent successfully!');
                    })
                    .catch(function (error) {
                        $log.error(error);
                    })
                    .finally(function () {
                      vm.sendButtonPressed = true;
                    });
        };

        vm.createNewMessage = function () {
          vm.showSuccessSection = false;
          vm.isReplyMessage = false;
          $state.go("newMessage", {}, {reload: true})
        }

        function setSelectionRange(input, selectionStart, selectionEnd) {
            if (input.setSelectionRange) {
                input.focus();
                input.setSelectionRange(selectionStart, selectionEnd);
            } else if (input.createTextRange) {
                var range = input.createTextRange();
                range.collapse(true);
                range.moveEnd('character', selectionEnd);
                range.moveStart('character', selectionStart);
                range.select();
            }
        }

        function setCaretToPos(input, pos) {
            setSelectionRange(input, pos, pos);
        }

        /*function formatResponseBody(body) {
         var replyText ="\n\n----------------------------------------------------------------------------------------------------------------------------";
         body = body ? '\n' + String(body).replace(/<[^>]+>/gm, '') : '';
         return replyText + body;
         }*/

        vm.init();
    }
}());
